import { message } from "skin/event";
import { status } from "skin/event/status";

const loyalty = (obj, ms, story, data, d, action) => {
	if (obj.type === "control" && ["add", "delete"].includes(obj.action)) return fn(data);
	return status.action;
};

export default loyalty;

function fn(data) {
	const check = data.s.values.fld.checkUseLoyalty;
	if (!check) return status.action;
	message("Программа лояльности уже используется", "Внимание");
	return status.ignore;
}
